/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CompetenceTemplateDTO,
    CompetenceTemplateDTOFromJSON,
    CompetenceTemplateDTOToJSON,
    CompetenceTemplateDTOPagedResponse,
    CompetenceTemplateDTOPagedResponseFromJSON,
    CompetenceTemplateDTOPagedResponseToJSON,
    CompetenceTemplateQueryParams,
    CompetenceTemplateQueryParamsFromJSON,
    CompetenceTemplateQueryParamsToJSON,
    CompetenceTemplateUpdateDTO,
    CompetenceTemplateUpdateDTOFromJSON,
    CompetenceTemplateUpdateDTOToJSON,
} from '../models';

export interface ApiCompetenceTemplateAddPostRequest {
    competenceTemplateUpdateDTO?: CompetenceTemplateUpdateDTO;
}

export interface ApiCompetenceTemplateDeleteIdDeleteRequest {
    id: string;
}

export interface ApiCompetenceTemplateGetAllPostRequest {
    competenceTemplateQueryParams?: CompetenceTemplateQueryParams;
}

export interface ApiCompetenceTemplateGetByIdIdGetRequest {
    id: string;
}

export interface ApiCompetenceTemplateUpdateIdPutRequest {
    id: string;
    competenceTemplateUpdateDTO?: CompetenceTemplateUpdateDTO;
}

/**
 * 
 */
export class CompetenceTemplateApi extends runtime.BaseAPI {

    /**
     */
    async apiCompetenceTemplateAddPostRaw(requestParameters: ApiCompetenceTemplateAddPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CompetenceTemplate/Add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompetenceTemplateUpdateDTOToJSON(requestParameters.competenceTemplateUpdateDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiCompetenceTemplateAddPost(requestParameters: ApiCompetenceTemplateAddPostRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.apiCompetenceTemplateAddPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiCompetenceTemplateDeleteIdDeleteRaw(requestParameters: ApiCompetenceTemplateDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiCompetenceTemplateDeleteIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CompetenceTemplate/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiCompetenceTemplateDeleteIdDelete(requestParameters: ApiCompetenceTemplateDeleteIdDeleteRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiCompetenceTemplateDeleteIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiCompetenceTemplateGetAllPostRaw(requestParameters: ApiCompetenceTemplateGetAllPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CompetenceTemplateDTOPagedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CompetenceTemplate/GetAll`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompetenceTemplateQueryParamsToJSON(requestParameters.competenceTemplateQueryParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetenceTemplateDTOPagedResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiCompetenceTemplateGetAllPost(requestParameters: ApiCompetenceTemplateGetAllPostRequest = {}, initOverrides?: RequestInit): Promise<CompetenceTemplateDTOPagedResponse> {
        const response = await this.apiCompetenceTemplateGetAllPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiCompetenceTemplateGetByIdIdGetRaw(requestParameters: ApiCompetenceTemplateGetByIdIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CompetenceTemplateDTO>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiCompetenceTemplateGetByIdIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CompetenceTemplate/GetById/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompetenceTemplateDTOFromJSON(jsonValue));
    }

    /**
     */
    async apiCompetenceTemplateGetByIdIdGet(requestParameters: ApiCompetenceTemplateGetByIdIdGetRequest, initOverrides?: RequestInit): Promise<CompetenceTemplateDTO> {
        const response = await this.apiCompetenceTemplateGetByIdIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiCompetenceTemplateUpdateIdPutRaw(requestParameters: ApiCompetenceTemplateUpdateIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiCompetenceTemplateUpdateIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/CompetenceTemplate/Update/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompetenceTemplateUpdateDTOToJSON(requestParameters.competenceTemplateUpdateDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiCompetenceTemplateUpdateIdPut(requestParameters: ApiCompetenceTemplateUpdateIdPutRequest, initOverrides?: RequestInit): Promise<void> {
        await this.apiCompetenceTemplateUpdateIdPutRaw(requestParameters, initOverrides);
    }

}
